import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from 'src/app/infrastructure/api-client/api-client';
import { ShareAddReservationRequest } from 'src/app/model/api/api-request/share-add-reservation-request';
import { ClientInfo } from 'src/app/model/interfaces/client-info';
import { LotteryClass } from 'src/app/model/interfaces/lottery-class';
import { Order } from 'src/app/model/interfaces/order';
import { Share } from 'src/app/model/interfaces/share';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ClientService } from 'src/app/services/client.service';
import { RecurringUpsaleRequest } from '../../model/api/api-request/recurring-upsale-request';
import { UpsaleNeighbourTicketReservationRequest } from '../../model/api/api-request/upsale-neighbour-ticket-reservation-request';
import { UpsaleTicketReservationRequest } from '../../model/api/api-request/upsale-ticket-reservation-request';
import { RecurringUpsaleResponse } from '../../model/interfaces/RecurringUpsaleResponse';
import { UpsaleTicketReservation } from '../../model/interfaces/UpsaleTicketReservation';
import { PaymentInterval } from '../../../model/types/payment-interval';

@Injectable()
export class UpsaleRepository
{
    protected readonly apiClient: ApiClient;
    private readonly clientService: ClientService;

    public constructor(apiClient: ApiClient, clientService: ClientService, private environment: AppConfigService)
    {
        this.apiClient = apiClient;
        this.clientService = clientService;
    }

    public addSharedReservation(order: Order | number, lotteryClass: LotteryClass | number, share: Share): Observable<Order>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new ShareAddReservationRequest(order, share, lotteryClass, webapiBasepath);
        return this.apiClient.post(request);
    }

    public getTicketReservation(playerId: number, ticketNumber: number, ticketLetter: string): Observable<UpsaleTicketReservation>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new UpsaleTicketReservationRequest(playerId, ticketNumber, ticketLetter, webapiBasepath);
        return this.apiClient.post(request);
    }

    public getNeighbourTicketReservation(playerId: number, ticketNumber: number): Observable<UpsaleTicketReservation>
    {
        const webapiBasepath = this.environment.config['webapibasepath'];
        const request = new UpsaleNeighbourTicketReservationRequest(playerId, ticketNumber, webapiBasepath);
        return this.apiClient.post(request);
    }

    public postRecurringUpsale(
        playerId: number,
        ticketNumber: number,
        ticketLetter: string,
        classCount: PaymentInterval,
        regNumber: number,
        accountnumber: number,
        crpDate: string,
        cprControlDigits: string): Observable<RecurringUpsaleResponse>
    {
        // need more info for tracking user agent, referrer and channel
        const clientInfo: ClientInfo = this.clientService.getClientInfo();
        const webapiBasepath = this.environment.config['webapibasepath'];

        const request = new RecurringUpsaleRequest(playerId, ticketNumber, ticketLetter, classCount, regNumber, accountnumber, crpDate, cprControlDigits, clientInfo, webapiBasepath);
        return this.apiClient.post(request);
    }
}
